import { memo } from 'react';

import Path from 'path-to-regexp';
import { Redirect } from 'react-router-dom';

import { env } from '@/constant/env';
import { NEW_WF_OVERVIEW_ROUTE, type WithRouterProps } from '@/constant/routes';
import { WorkflowOverviewContextProvider } from './context.workflowOverview';
import { OldWorkflowOverview } from './workflowOverview';

/** @deprecated Use the new workflow overview instead. */
export const OldWorkflowOverviewWithContext = memo((props: WithRouterProps) => {
  // ? this check will handle backward compatibility with all existing URLs
  if (!env.FEATURE_FLAGS.USE_OLD_WF_OVERVIEW) {
    const { id } = props.match.params;
    return <Redirect to={Path.compile(NEW_WF_OVERVIEW_ROUTE)({ id })} />;
  }

  return (
    <WorkflowOverviewContextProvider>
      <OldWorkflowOverview {...props} />
    </WorkflowOverviewContextProvider>
  );
});
